import React, { useEffect, useMemo } from 'react';
import EnterButton from "../../global/EnterButton";
import {
  BillFromMachine,
  BillStatus,
  INITIATED,
  InternalBillType,
  isEmpty,
  isRoleAllowed,
  printDebugLog,
  SEND_TO_KITCHEN,
  ROLE_CREATE,
  BILLMGMT,
  ONLINEBILLMGMT
} from '../../../constants/constant';
import { getPartialPayButtonName } from './quickBillController';
import { FormControl, FormHelperText } from '../../ui';
const RestoButton = ({
    paymentDetails,isOthHomeDelv,delvNameOth,tripDetails,externalBillDetails,generateOtp,customerData,
    billedFrom,billStatus,
    kot, snpLoader,isPaid, columnList,
    kotPrintNoWise,partilBillAvail,duesAmt,billUtils,deletBillOption,ePayInvoice,settleDown,takenPartialPay,
    kotprint,setPrintKotNoDialog,handleUpdateTripStatus,handlePartialPayChange,handlePayLater,
    initiatePayment,handleGenBill,printBillAfterPay,finalSettle,deleteEntireBill,handleInitiatePayLink
  }) => {

    const shouldShowKotButton = useMemo(
        () =>
            billedFrom === BillFromMachine.BILLING_MACHINE ||
            (billedFrom >= BillFromMachine.WEB &&
                (isEmpty(tripDetails.tripStatus) ||
                INITIATED === tripDetails.tripStatus ||
                SEND_TO_KITCHEN === tripDetails.tripStatus )),
        [billedFrom, tripDetails.tripStatus]
    );

    const shouldShowPreviousKotBtn = useMemo(() => kotPrintNoWise && kot > 0 , [kotPrintNoWise,kot]);
    const shouldShowFoodStatusBtn = useMemo(() => billedFrom === BillFromMachine.WEB , [billedFrom]);
    const shouldShowPartialBtn = useMemo(() => isEmpty(externalBillDetails.hotelBillNo) && partilBillAvail , [externalBillDetails.hotelBillNo,partilBillAvail]);
    const shouldShowPayLaterBtn = useMemo(() => !isEmpty(externalBillDetails.hotelBillNo) &&  billStatus === BillStatus.INITIATED, [externalBillDetails.hotelBillNo,billStatus]);
    const shouldDeleteBillBtn = useMemo(() => (billStatus >= BillStatus.INITIATED && deletBillOption) 
            || billStatus === BillStatus.HOMEDELIVERYINITIATED , [billStatus,deletBillOption]);
    const shouldShowEpayBtn = useMemo(() => ePayInvoice && !isPaid && billStatus !== BillStatus.NOTPAID
        && billUtils.billType !== InternalBillType.Home, [ePayInvoice, isPaid, billStatus, billUtils.billType]);


    const disableKotSaveBtn = useMemo(() =>
        (billedFrom === BillFromMachine.BILLING_MACHINE && isPaid) ||
        (Array.isArray(columnList) && columnList.length === 0) ||
        snpLoader || (!isEmpty(externalBillDetails.hotelBillNo) && externalBillDetails.payLaterSignal)
        , [billedFrom, snpLoader, isPaid, externalBillDetails.hotelBillNo, externalBillDetails.payLaterSignal, columnList]);

    const disablePartialBtn = useMemo(() =>
        (Array.isArray(columnList) && columnList.length === 0) ||
        snpLoader || billStatus === BillStatus.NOTPAID || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
        , [snpLoader, billStatus, columnList]);

    const disablePayLaterBtn = useMemo(() =>
        (Array.isArray(columnList) && columnList.length === 0) ||
        snpLoader || externalBillDetails.payLaterSignal || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
        , [snpLoader, externalBillDetails.payLaterSignal, columnList]);


    const disablePayBtn = useMemo(() =>
        (Array.isArray(columnList) && columnList.length === 0) 
        || isPaid || snpLoader || (!isEmpty(externalBillDetails.hotelBillNo) && externalBillDetails.payLaterSignal) || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
        || !(billStatus === BillStatus.INITIATED || billUtils.billType !== InternalBillType.BookTable)
        , [snpLoader, isPaid, externalBillDetails.hotelBillNo, externalBillDetails.payLaterSignal, billStatus, billUtils.billType, columnList]);

    const disableGenerateBtn = useMemo(() =>
        (Array.isArray(columnList) && columnList.length === 0) ||
        snpLoader || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)
        || !(!isPaid && billStatus === BillStatus.INITIATED)
        , [snpLoader, isPaid, billStatus, columnList]);


    const disableSettleBillBtn = useMemo(() =>
        billStatus <= BillStatus.PARTIALLYPAID
        || settleDown ||
        billUtils.billType === InternalBillType.BookTable
        , [billStatus,settleDown, billUtils.billType]);

    const buttons = useMemo(
        () =>
            [
                shouldShowKotButton && {
                    text: kot > 0 ? "Update Kitchen Copy" : "Kitchen Copy",
                    disabled: disableKotSaveBtn,
                    onClick: () => kotprint(true),
                    hotkey: 'ctrl+k',
                },
                shouldShowPreviousKotBtn &&  {
                    text: "Previous KOT",
                    onClick: setPrintKotNoDialog,
                },
                {
                    text:"Save Bill",
                    disabled:disableKotSaveBtn,
                    onClick: ()=> kotprint(false),
                    hotkey: 'ctrl+s',
                },
                shouldShowFoodStatusBtn && {
                    text:"Update Food Status",
                    onClick: handleUpdateTripStatus,
                },
                shouldShowPartialBtn && {
                    text:getPartialPayButtonName(billStatus,duesAmt),
                    disabled:disablePartialBtn,
                    onClick: handlePartialPayChange,
                    hotkey: 'ctrl+alt+1',
                },
                shouldShowPayLaterBtn && {
                    text:"Pay Later",
                    disabled:disablePayLaterBtn,
                    onClick: handlePayLater,
                    hotkey: 'ctrl+alt+2',
                },
                {
                    text:"Initiate Payment",
                    disabled:disablePayBtn,
                    onClick: () => initiatePayment(false),
                    hotkey: 'ctrl+i',
                },
                {
                    text:"Generate Bill",
                    disabled:disableGenerateBtn,
                    onClick: handleGenBill,
                    hotkey: 'ctrl+g',
                },
                {
                    text:"Print Customer Bill",
                    disabled:!isPaid,
                    onClick: () => printBillAfterPay(0),
                    hotkey: 'ctrl+alt+3',
                },
                {
                    text:"Settle Bill",
                    disabled:disableSettleBillBtn,
                    onClick: finalSettle,
                    hotkey: 'ctrl+s',
                },
                {
                    text:"Print Shop Bill",
                    disabled:!isPaid,
                    onClick: () => printBillAfterPay(1),
                    hotkey: 'ctrl+alt+4',
                },
                shouldDeleteBillBtn && {
                    text: billStatus === BillStatus.HOMEDELIVERYINITIATED ?  "Remove Bill" :"Delete Bill",
                    onClick:{deleteEntireBill}
                },
                shouldShowEpayBtn && {
                    text: "Generate Bill with E-Pay",
                    disabled:disableGenerateBtn,
                    onClick:{handleInitiatePayLink}
                }
            ].filter(Boolean), // Remove null/false values
        [
            paymentDetails,
            columnList,
            isOthHomeDelv,delvNameOth,tripDetails,externalBillDetails,generateOtp,customerData,billUtils,
            shouldShowKotButton,
            shouldShowPreviousKotBtn,
            shouldShowFoodStatusBtn,
            shouldShowPartialBtn,
            shouldShowPayLaterBtn,
            shouldDeleteBillBtn,
            shouldShowEpayBtn,
            disableKotSaveBtn,
            disablePartialBtn,
            disablePayLaterBtn,
            disablePayBtn,
            disableGenerateBtn,
            disableSettleBillBtn,
            kot,billStatus,duesAmt,isPaid,
        ]
    );

    useEffect(() => {
        const handleKeyDown = (event) => {
            printDebugLog("RestoButton keyDown ",event.ctrlKey,event.altKey,event.key);
            if (event.ctrlKey && event.key === 'k') {
                event.preventDefault();
                if (shouldShowKotButton && !disableKotSaveBtn) {
                    kotprint(true);
                }
            } else if (event.ctrlKey && event.key === 's') {
                event.preventDefault();
                if (!disableKotSaveBtn) {
                    kotprint(false);
                } else if (!disableSettleBillBtn) {
                    finalSettle();
                }
            } else if (event.ctrlKey && event.key === 'i') {
                event.preventDefault();
                if (!disablePayBtn) {
                    initiatePayment(false);
                }
            } else if (event.ctrlKey && event.key === 'g') {
                event.preventDefault();
                if (!disableGenerateBtn) {
                    handleGenBill();
                }
            } else if (event.ctrlKey && event.altKey && event.key === '1') {
                event.preventDefault();
                if (shouldShowPartialBtn && !disablePartialBtn) {
                    handlePartialPayChange();
                }
            } else if (event.ctrlKey && event.altKey && event.key === '2') {
                event.preventDefault();
                if (shouldShowPayLaterBtn && !disablePayLaterBtn) {
                    handlePayLater();
                }
            } else if (event.ctrlKey && event.altKey && event.key === '3') {
                event.preventDefault();
                if (isPaid) {
                    printBillAfterPay(0);
                }
            } else if (event.ctrlKey && event.altKey && event.key === '4') {
                event.preventDefault();
                if (isPaid) {
                    printBillAfterPay(1);
                }
            } 
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [paymentDetails,
        isOthHomeDelv,delvNameOth,tripDetails,externalBillDetails,generateOtp,customerData,
        shouldShowKotButton,shouldShowPayLaterBtn,shouldShowPartialBtn, disableKotSaveBtn,
        disableSettleBillBtn,
        disablePayBtn,disableGenerateBtn,disablePayLaterBtn,
        disablePartialBtn,isPaid
    ]);



    return (
        <div className="billing-button-grid-container">
            {buttons.map(({ text, disabled = false, onClick,hotkey }, index) => (
                <FormControl key={index}>
                    <EnterButton
                        variant="contained"
                        color="primary"
                        disabled={disabled}
                        disableRipple
                        aria-describedby="button-helper-text"
                        sx={{
                            WebkitTapHighlightColor: 'transparent',
                            transition: 'background-color 0.2s ease',
                        }}
                        onPointerDown={typeof onClick === 'function' ? onClick : () => {}}>
                        {text}
                    </EnterButton>
                    {
                        !isEmpty(hotkey) &&
                        <FormHelperText sx={{ textAlign: 'center' }} id="button-helper-text">
                            <span style={{ color: "#892024" , fontWeight:"bold" }}>{`Keyboard ${hotkey}`}</span>
                        </FormHelperText>
                    }
                </FormControl>
            ))}
        </div>
    );
};

export default React.memo(RestoButton);